import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import './gallery.css';






import con1 from '../../assets/con1.jpg';
import con2 from '../../assets/con2.jpg';
import con3 from '../../assets/con3.jpg'; 
import con4 from '../../assets/con4.jpg';
import con5 from '../../assets/con5.jpg';
import con6 from '../../assets/con6.jpg';
import con7 from '../../assets/con7.jpg';
import con8 from '../../assets/con8.jpg';
import con9 from '../../assets/con9.jpg';
import con10 from '../../assets/con10.jpg';
import con11 from '../../assets/con11.jpg';
import con12 from '../../assets/con12.jpg';
import con13 from '../../assets/con13.jpg';
import con14 from '../../assets/con14.jpg';
import con15 from '../../assets/con15.jpg';
import con16 from '../../assets/con16.jpg';
import con17 from '../../assets/con17.jpg';
import con18 from '../../assets/con18.jpg';
import con19 from '../../assets/con19.jpg';
import con20 from '../../assets/con20.jpg';
import con21 from '../../assets/con21.jpg';
import con22 from '../../assets/con22.jpg';
import con23 from '../../assets/con23.jpg'; 
import con24 from '../../assets/con24.jpg';
import con25 from '../../assets/con25.jpg';
import con26 from '../../assets/con26.jpg';
import con27 from '../../assets/con27.jpg';
import con28 from '../../assets/con28.jpg';
import con29 from '../../assets/con29.jpg';
import con30 from '../../assets/con30.jpg';
import con31 from '../../assets/con31.jpg';
import con32 from '../../assets/con32.jpg';
import con33 from '../../assets/con33.jpg';
import con34 from '../../assets/con34.jpg';
import con35 from '../../assets/con35.jpg';
import con36 from '../../assets/con36.jpg';
import con37 from '../../assets/con37.jpg';
import con38 from '../../assets/con38.jpg';
import con39 from '../../assets/con39.jpg';
import con40 from '../../assets/con40.jpg';
import con41 from '../../assets/con41.jpg';
import con42 from '../../assets/con42.jpg';
import con43 from '../../assets/con43.jpg';
import con44 from '../../assets/con44.jpg';
import con45 from '../../assets/con45.jpg';
import con46 from '../../assets/con46.jpg';
import con47 from '../../assets/con47.jpg';
import con48 from '../../assets/con48.jpg';
import con49 from '../../assets/con49.jpg';
import con50 from '../../assets/con50.jpg';
import con51 from '../../assets/con51.jpg';
import con52 from '../../assets/con52.jpg';
import con53 from '../../assets/con53.jpg';
import con54 from '../../assets/con54.jpg';
import con55 from '../../assets/con55.jpg';
import con56 from '../../assets/con56.jpg';
import con57 from '../../assets/con57.jpg';
import con58 from '../../assets/con58.jpg';
import con59 from '../../assets/con59.jpg';
import con60 from '../../assets/con60.jpg';







import Graduationimg1 from '../../assets/grad1.jpg';
import Graduationimg2 from '../../assets/grad2.jpg';
import Graduationimg3 from '../../assets/grad3.jpg';
import Graduationimg4 from '../../assets/grad4.jpg';
import Graduationimg5 from '../../assets/grad5.jpg';
import Graduationimg6 from '../../assets/grad6.jpg';
import Graduationimg7 from '../../assets/grad7.jpg';
import Graduationimg8 from '../../assets/grad8.jpg';
import Graduationimg9 from '../../assets/grad9.jpg';
import Graduationimg10 from '../../assets/grad10.jpg';
import Graduationimg11 from '../../assets/grad11.jpg';
import Graduationimg12 from '../../assets/grad12.jpg';
import Graduationimg13 from '../../assets/grad13.jpg';
import Graduationimg14 from '../../assets/grad14.jpg';
import Graduationimg15 from '../../assets/grad15.jpg';
import Graduationimg16 from '../../assets/grad16.jpg';
import Graduationimg17 from '../../assets/grad17.jpg';
import Graduationimg18 from '../../assets/grad18.jpg';





import Programimg2 from '../../assets/awareness2.jpg';
import Programimg3 from '../../assets/awareness3.jpg';
import Programimg4 from '../../assets/awareness4.jpg';
import Programimg5 from '../../assets/awareness5.jpg';
import Programimg6 from '../../assets/awareness10.jpg';
import Programimg7 from '../../assets/awareness7.jpg';
import Programimg8 from '../../assets/awareness8.jpg';
import Programimg9 from '../../assets/awareness9.jpg';
import Programimg10 from '../../assets/awareness6.jpg';
import Programimg11 from '../../assets/awareness11.jpg';
import Programimg12 from '../../assets/awareness12.jpg';
import Programimg13 from '../../assets/awareness13.jpg';



import Communityimg1 from '../../assets/wsdoimg1.jpg';
import Communityimg2 from '../../assets/wsdoimg7.jpg';
import Communityimg3 from '../../assets/wsdoimg14.jpg';
import Communityimg4 from '../../assets/wsdoimg17.jpg';
import Communityimg5 from '../../assets/wsdoimg13.jpg';
import Communityimg6 from '../../assets/wsdoimg9.jpg';
import Communityimg7 from '../../assets/wsdoimg4.jpg';
import Communityimg8 from '../../assets/wsdoimg10.jpg';
import Communityimg9 from '../../assets/wsdoimg15.jpg';
import Communityimg10 from '../../assets/wsdoimg8.jpg';
import Communityimg11 from '../../assets/wsdoimg5.jpg';
import Communityimg12 from '../../assets/wsdoimg2.jpg';



import EyeCampimg1 from '../../assets/eyecamp1.jpg';
import EyeCampimg2 from '../../assets/eyecamp2.jpg';
import EyeCampimg3 from '../../assets/eyecamp3.jpg';
import EyeCampimg4 from '../../assets/eyecamp4.jpg';
import EyeCampimg5 from '../../assets/eyecamp5.jpg';
import EyeCampimg6 from '../../assets/eyecamp6.jpg';
import EyeCampimg7 from '../../assets/eyecamp7.jpg';
import EyeCampimg8 from '../../assets/eyecamp8.jpg';
import EyeCampimg10 from '../../assets/eyecamp10.jpg';
import EyeCampimg11 from '../../assets/eyecamp11.jpg';
import EyeCampimg12 from '../../assets/eyecamp12.jpg';
import EyeCampimg13 from '../../assets/eyecamp1.jpg';



const sections = [

  {
    title: 'DIYATHARIPPU - EYE CARE 2026, 1st International Optometric Conference in Sri Lanka',
    images: [con1, con2, con3, con4, con5, con6, con7, con8, con9, con10, con11, con12, con13, con14, con15, con16, con17, con18, con19, con20, con21, con22, con23, con24, con25, con26, con27, con28, con29, con30, con31, con32, con33, con34, con35, con36, con37, con38, con39, con40, con41, con42, con43, con44, con45, con46, con47, con48, con49, con50, con51, con52, con53, con54, con55, con56, con57, con58, con59,  con60],
  },

  {
    title: 'Graduations',
    images: [Graduationimg1, Graduationimg2, Graduationimg3, Graduationimg4, Graduationimg5, Graduationimg6, Graduationimg7, Graduationimg8, Graduationimg9, Graduationimg10, Graduationimg11, Graduationimg12, Graduationimg13, Graduationimg14, Graduationimg15, Graduationimg16, Graduationimg17, Graduationimg18],
  },
  {
    title: 'Awareness Programs',
    images: [ Programimg2, Programimg3, Programimg4, Programimg5, Programimg6,  Programimg7, Programimg8, Programimg9, Programimg10, Programimg11, Programimg12, Programimg13],
  },
  {
    title: 'Eye Checkup Camps',
    images: [EyeCampimg1, EyeCampimg2, EyeCampimg3, EyeCampimg4, EyeCampimg5, EyeCampimg6, EyeCampimg7, EyeCampimg8, EyeCampimg10, EyeCampimg11, EyeCampimg12, EyeCampimg13 ],
  },
  {
    title: 'Community Engagement',
    images: [Communityimg1, Communityimg2, Communityimg3, Communityimg4, Communityimg5, Communityimg6, Communityimg7, Communityimg8, , Communityimg9, Communityimg10, Communityimg11, Communityimg12],
  },

];

const Gallery = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Gallery</h1>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};

export default Gallery;
